/*
 * Module for the response editor
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "configuration/properties",
  "./snippetEditorModalView",
  "modules/shared/ckeditor5/ckEditor5Module",
], function (
  Marionette,
  Backbone,
  Messenger,
  Properties,
  SnippetEditorModalView,
  Es6CkEditor5Module,
) {
  "use strict";

  const CkEditor5Module = Es6CkEditor5Module.default || Es6CkEditor5Module;

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.namespace = options.namespace;
      this.name = "snippetEditorModal";
      this._setUpVents();
    },
    show: function ({ snippet, languageId, touchpointId }) {
      const snippetEditorModalModel = new Backbone.Model({
        id: snippet.id,
        languageId,
        touchpointId,
        value: snippet.get("value"),
      });

      this.model = snippetEditorModalModel;

      this.view = new SnippetEditorModalView.snippetEditorModalView({
        model: snippetEditorModalModel,
      });
      this.htmlEditor = this.addSubModule(
        new CkEditor5Module.ckEditor5Module({ namespace: this.name, region: this.view.htmlEditor }),
      );

      this.view.on("cancel", this._onCancel, this);
      this.view.on("done", this._onDone, this);
      this.view.on("show", this._showSubViews, this);

      this.showRegion(this.view);
    },
    _onCancel: function () {
      // Ignore any changes to the snippet value
      Messenger.vent.trigger("close:modal");
    },
    _onDone: async function () {
      // Only update if the CKEditor actually has changes.  Cannot just compare with what we
      // currently have, because the CKEditor does some modification of the HTML to "sanitize" it.
      if (!this.htmlEditor.isDirty()) {
        Messenger.vent.trigger("close:modal");
        return;
      }
      const newSnippetValue = this.htmlEditor.getResponseWithoutTags();
      const validateSnippetValue = await this._validateSnippetValue(newSnippetValue);
      if (validateSnippetValue.get("isValid")) {
        Messenger.vent.trigger("update:snippet:value", newSnippetValue);
        Messenger.vent.trigger("close:modal");
      } else {
        Messenger.okDialog(validateSnippetValue.get("errorMessage"));
      }
    },
    _showSubViews: function () {
      const languageId = this.model.get("languageId");
      const touchpointId = this.model.get("touchpointId");
      const allowAiFeatures = this.options.allowAiFeatures;
      let htmlEditorConfig = {
        languageId,
        response: this.model.get("value"),
        skipCollaborationFeatures: true,
        skipContentMappingLink: true,
        skipImage: true,
        skipOpenSnippetEditor: true,
        skipSnippets: true,
        skipTopicLink: true,
        snippetIdToBlockFromInsert: this.model.id,
        touchPointId: touchpointId,
        allowAiFeatures: allowAiFeatures,
        skipExpandWithContext: true,
        skipResponseTransform: true,
      };
      if (languageId && touchpointId) {
        htmlEditorConfig = {
          ...htmlEditorConfig,
          skipContentMappingLink: false,
          skipImage: false,
          skipTopicLink: false,
        };
      }
      this.htmlEditor.show(htmlEditorConfig);
    },
    _setUpVents: function () {
      Messenger.vent.on(Messenger.getFullName("ckeditor:initializeError", this.name), () =>
        Messenger.vent.trigger("close:modal"),
      );
    },
    _validateSnippetValue: async function (value) {
      const validateModel = new Backbone.Model({
        isValid: false,
        languageId: this.model.get("languageId"),
        touchpointId: this.model.get("touchpointId"),
        value,
      });
      const kbId = Messenger.reqres.request("active:kb");
      validateModel.url = () => `${Properties.rootURL}/${kbId}/snippets/validateValue`;
      try {
        await validateModel.saveModelPromise();
      } catch (e) {
        validateModel.set("errorMessage", e.toString());
      }
      return validateModel;
    },
  });
});
